// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export type FeaturedProductsState = {
    isLoading: boolean;
    totalItems: number;
};

export type xFeaturedProductsState = {
    xFeaturedProducts: FeaturedProductsState;
};

const initialFeaturedProductsState: FeaturedProductsState = {
    isLoading: false,
    totalItems: 0,
};

const xFeaturedProducts = createTypedReducerWithImmer(initialFeaturedProductsState, {
    "xFeaturedProducts/BeginLoadFeaturedProducts": (draft: Draft<FeaturedProductsState>) => {
        draft.isLoading = true;
    },
    "xFeaturedProducts/CompleteLoadFeaturedProducts": (draft: Draft<FeaturedProductsState>) => {
        draft.isLoading = false;
    },
    "xFeaturedProducts/TotalFeaturedItems": (draft: Draft<FeaturedProductsState>, actions: { totalItems: number }) => {
        draft.totalItems = actions.totalItems;
    },
});

(reducers as any).xFeaturedProducts = xFeaturedProducts;

type xFeaturedProductsReducers = {
    featuredProducts: typeof xFeaturedProducts;
};

export type xFeaturedProductsActions =
    | Parameters<xFeaturedProductsReducers[keyof xFeaturedProductsReducers]>[1]
    | AnyAction;
